// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const TextareaAutosize = require('react-textarea-autosize').default
const _ = require('lodash')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { CapsuleButton } = require('client-v2/common/components/buttons')
// Container imports
const ArticleProfileCommentsItem = require('./comments-item')

const MAX_COMMENT_LENGTH = 10000
const COMMENTS_PER_PAGE = 10
const INITIAL_COMMENTS_THRESHOLD = 5

// BEM Block entity definition
const bem = BemEntity('ArticleProfileCommentsV2')

function ArticleProfileComments(props) {
  return (
    tag('section', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(CommentForm, props),
      tag(CommentsList, props)
    )
  )
}

ArticleProfileComments.propTypes = {
  // Flags
  isMoreAvailable: PropTypes.bool,
  isLoading: PropTypes.bool,
  // Values
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object.isRequired,
  // Callbacks
  onFormSubmit: PropTypes.func,
  onItemDelete: PropTypes.func,
  onItemReport: PropTypes.func,
  onItemUserClick: PropTypes.func,
  onShowMore: PropTypes.func
}

module.exports = ArticleProfileComments

// BEM Block entity Element components

function CommentForm(props) {
  const { article, user, isLoading } = props
  const [ inputValue, setInputValue ] = React.useState('')

  if (!user.loggedIn) {
    return null
  }

  const onReset = event => {
    event.preventDefault()
    setInputValue('')
  }

  const onSubmit = event => {
    event.preventDefault()
    props.onFormSubmit({
      article,
      user,
      commentText: inputValue
    })
    setInputValue('')
  }

  const onInputChange = event => {
    setInputValue(event.target.value)
  }

  const placeholder = isLoading
  ? 'Fetching comments...'
  : 'Add a public comment...'

  return (
    tag('form', {
      className: bem.element('form'),
      onReset,
      onSubmit
    },
      tag('div', {
        className: bem.element('form-field')
      },
        tag(UserAvatar, {
          className: bem.element('form-icon'),
          user: user,
          visible: true
        }),
        tag(TextareaAutosize, {
          className: bem.element('form-input'),
          disabled: isLoading,
          maxLength: MAX_COMMENT_LENGTH,
          placeholder,
          value: inputValue,
          onChange: onInputChange
        })
      ),

      tag('div', {
        className: bem.element('form-buttons', {
          submittable: inputValue !== ''
        })
      },
        tag(CapsuleButton, {
          className: bem.element('form-reset'),
          type: 'reset'
        },
          'Cancel'
        ),
        tag(CapsuleButton, {
          className: bem.element('form-submit'),
          type: 'submit'
        },
          'Comment'
        )
      )
    )
  )
}

function CommentsList(props) {
  const { article, items, user } = props
  const [visibleThreshold, setVisibleThreshold] = React.useState(INITIAL_COMMENTS_THRESHOLD)

  const onShowMore = () => {
    setVisibleThreshold(visibleThreshold + COMMENTS_PER_PAGE)
  }

  if (!items.length || props.isLoading) {
    return null
  }
  return ([
    tag('ul', {
      className: bem.element('list')
    },
      _.slice(items, 0, visibleThreshold)
        .map(comment => (
          tag(ArticleProfileCommentsItem, {
            key: `comments-item:${comment.id}`,
            className: bem.element('list-item'),
            article,
            comment,
            user,
            onDeleteClick: props.onItemDelete,
            onReportClick: props.onItemReport,
            onUserClick: props.onItemUserClick
          })
      ))
    ),
    tag(MoreButton, {
      isVisible: visibleThreshold < items.length,
      onShowMore
    })
    ]
  )
}

function MoreButton(props) {
  if (!props.isVisible) {
    return null
  }
  return (
    tag(CapsuleButton, {
      className: bem.element('more-button'),
      onClick: props.onShowMore
    },
      'Show more'
    )
  )
}
